import { TimePicker, TimePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import React, { FC, useEffect, useRef } from 'react';

const TimePickerWithDots: FC<TimePickerProps> = props => {
  const divElem = useRef(null);
  const inputElem = useRef<HTMLInputElement | null>(null);
  const prevDataValue = useRef<string>('');

  const onInputChange = ({ target }: any) => {
    if (prevDataValue.current.length > target.value.length) {
      prevDataValue.current = target.value;
      return;
    }

    if (target.value.length === 2) {
      target.value += ':';
    }

    if (target.value.length > 5) {
      target.value = target.value.substring(0, 5);
    }

    prevDataValue.current = target.value;
  };

  useEffect(() => {
    return () => {
      inputElem?.current?.removeEventListener('input', onInputChange);
    };
  }, []);

  const onTimeChange = (date: Dayjs, dateString: string | string[]) => {
    if (inputElem?.current && !dateString) {
      inputElem.current.value = dateString;
      prevDataValue.current = dateString;
    }
    props?.onChange?.(date, dateString);
  };

  return (
    <TimePicker
      {...props}
      ref={divElem}
      onChange={onTimeChange}
      onFocus={(e: React.FocusEvent<HTMLElement>, info: any) => {
        if (!inputElem.current) {
          const elem: HTMLInputElement | null =
            (divElem?.current as any)?.nativeElement?.children[0]?.children[0] || null;
          inputElem.current = elem;
          inputElem.current?.addEventListener('input', onInputChange);
        }
        props?.onFocus?.(e, info);
      }}
    />
  );
};

export default TimePickerWithDots;
